module.exports = __webpack_public_path__ + "img/shape_trapezoid.12ce228c.png";